import api from 'mastodon/api';
import { MULTI_ACCOUNT_REQUEST_TIMEOUT } from 'mastodon/api/multi_accounts_constants';
import { clearDrafts } from 'mastodon/features/messages/util/drafts';
import { clearActiveAccountIdInStorage } from 'mastodon/utils/multi_account_storage';

export async function logOut() {
  clearDrafts();

  // Clear the "last switched account" pointer too. Left behind, it comes back
  // out of step with the session the next time a different account signs in.
  clearActiveAccountIdInStorage();

  try {
    const response = await api(false).delete<{ redirect_to?: string }>(
      '/auth/sign_out',
      {
        headers: { Accept: 'application/json' },
        withCredentials: true,
        timeout: MULTI_ACCOUNT_REQUEST_TIMEOUT,
      },
    );

    if (response.status === 200 && response.data.redirect_to)
      window.location.href = response.data.redirect_to;
    else
      console.error(
        'Failed to log out, got an unexpected non-redirect response from the server',
        response,
      );
  } catch (error) {
    console.error('Failed to log out, response was an error', error);
  }
}
